import { Controller } from 'react-hook-form'
import { SelectInput } from '../../inputs'
import { useI18n } from '@ggs/i18n'
import { useCategoryTypeCategoryOptions } from '../../../local'
import { get } from 'lodash'

/**
 * @typedef {import('react-hook-form').FieldErrors} FieldErrors
 * @typedef {import('react-hook-form').FieldValues} FieldValues
 * @typedef {import('react-hook-form').Control<FieldValues>} FormControl
 */

/**
 * @typedef {Object} ProgramServiceFieldProps
 * @property {FieldErrors} errors
 * @property {FormControl} control
 */

/**
 * Provides program or services field form element.
 * @param {ProgramServiceFieldProps} props
 * @return {JSX.Element}
 */
const ProgramServiceField = ({ control, errors }) => {
  const { t } = useI18n()
  const hasError = Boolean(errors.serviceFilter)
  const errorMessage = errors.serviceFilter?.message || ''
  const categoryTypeNid = get(
    window || {},
    'drupalSettings.react.categoryTypes.programServiceNid',
    ''
  )
  const { categoryOptions } = useCategoryTypeCategoryOptions(categoryTypeNid)

  return (
    <Controller
      control={control}
      name="serviceFilter"
      defaultValue=""
      render={({ field }) => (
        <SelectInput
          id="form-quick-search-filter-category"
          label={t('Filter by Program or Service')}
          placeholder={t('Select program or service')}
          error={hasError}
          // @ts-ignore
          errorHelperText={errorMessage}
          selectOptions={categoryOptions}
          inputFields={field}
        />
      )}
    />
  )
}

export default ProgramServiceField
